import { IOrder } from '../types/Order';

export const getOrder = (item?: IOrder) => ({
  id: item?.id ?? 0,
  created_on: item?.created_on ?? '',
  order_type: item?.order_type ?? 0,
  total_amount: item?.total_amount ?? '',
  delivery_address_id: item?.delivery_address_id ?? 0,
  delivery_address_title: item?.delivery_address_title ?? '',
  client_id: item?.client_id ?? 0,
  courier_id: item?.courier_id ?? 0,
  branch_id: item?.branch_id ?? 0,
  source_type: item?.source_type ?? 0,
  message: item?.message ?? '',
  error_message: item?.error_message ?? '',
  order_no: item?.order_no ?? 0,
  responsible: item?.responsible ?? 0,
  bsp_id: item?.bsp_id ?? 0,
  board_id: item?.board_id ?? 0,
  workshift: item?.workshift ?? 0,
  layout: item?.layout ?? '',
  loop_no: item?.loop_no ?? 0,
  person: item?.person ?? 0,
  additional_id: item?.additional_id ?? 0,
  paid: item?.paid ?? '',
  grand_total: item?.grand_total ?? '',
  total_price: item?.total_price ?? null,
  cart: item?.cart ?? null,
  cash_returned: item?.cash_returned ?? '',
  sent_in: item?.sent_in ?? '',
  deleted_reason: item?.deleted_reason ?? 0,
  changed: item?.changed ?? false,
  delivery_length: item?.delivery_length ?? '',
  comment: item?.comment ?? '',
  outside: item?.outside ?? '',
  delivery_time: item?.delivery_time ?? '',
  delivery_on: item?.delivery_on ?? '',
  deleting_type: item?.deleting_type ?? 0,
  precheck: item?.precheck ?? false,
  last_status_id: item?.last_status_id ?? 0,
  last_status_updated_on: item?.last_status_updated_on ?? '',
  last_status_title: item?.last_status_title ?? '',
  last_payment_status_id: item?.last_payment_status_id ?? 0,
  last_payment_status_updated_on: item?.last_payment_status_updated_on ?? '',
  last_payment_status_title: item?.last_payment_status_title ?? '',
  last_payment_title: item?.last_payment_title ?? '',
  delivery_type: item?.delivery_type ?? 0,
  additional_order: item?.additional_order ?? false,
  additional_order_id: item?.additional_order_id ?? 0,
  deleted_reason_comment: item?.deleted_reason_comment ?? '',
  spsrc: item?.spsrc ?? '',
  modified_user_id: item?.modified_user_id ?? 0,
  modified_user_role: item?.modified_user_role ?? '',
  is_updating: item?.is_updating ?? false,
  modified_user_name: item?.modified_user_name ?? '',
  modify_type: item?.modify_type ?? '',
  order_accepted_on: item?.order_accepted_on ?? '',
  order_in_delivery_on: item?.order_in_delivery_on ?? '',
  courier_accepted_on: item?.courier_accepted_on ?? '',
  branch_accepted_on: item?.branch_accepted_on ?? '',
  courier_linked_qty: item?.courier_linked_qty ?? 0,
  last_payment_id: item?.last_payment_id ?? 0,
  last_payment_type_id: item?.last_payment_type_id ?? 0,
  dog_id: item?.dog_id ?? '',
  is_free_order: item?.is_free_order ?? false,
  ext_srv_order_id: item?.ext_srv_order_id ?? '',
  iiko_no: item?.iiko_no ?? '',
  iiko_order_id: item?.iiko_order_id ?? '',
  uniq_guid: item?.uniq_guid ?? '',
});

export const ordersAdapter = (data?: IOrder[]) =>
  data?.map(item => getOrder(item)) ?? [];

const toPositiveNumber = (value: unknown) => {
  const parsed = Number(value);
  return value != null && value !== '' && Number.isFinite(parsed) && parsed > 0
    ? parsed
    : null;
};

/**
 * Сумма заказа в списке — та же, что итог в деталях заказа: `totalPrice` из
 * расчёта (`cart.order.totalPrice`) уже учитывает скидку по промокоду или
 * акции, баллы и доставку. Нет расчёта — `total_price` (EVSAP-95), и только
 * потом `grand_total`, который скидку не учитывает.
 */
export const getOrderListTotal = (
  order: Pick<IOrder, 'grand_total' | 'total_price' | 'cart'>
) =>
  toPositiveNumber(order.cart?.order?.totalPrice) ??
  toPositiveNumber(order.total_price) ??
  Number(order.grand_total);
